// 1. Определяем, что может прийти от сервера
interface WindowConfig {
	game?: string;
	routerBasePath?: string;
	apiBasePath?: string;
	routerType?: "HashRouter" | "BrowserRouter";
}

declare global {
	interface Window {
		FX_CONFIG?: WindowConfig;
	}
}

// ВНИМАНИЕ! Должно совпадать с C# объектом GetIndexHtmlForGame::
interface AppConfig {
	game?: string;
	routerBasePath: string;
	apiBasePath: string;
	routerType: "HashRouter" | "BrowserRouter";
	normalizedBaseUrl: string;
}

// 2. Читаем конфигурацию из window, если она есть
const windowConfig = window.FX_CONFIG || {};

// 3. Определяем routerBasePath
//    - standalone режим использует HashRouter, ему не нужен basename.
//    - В обычном режиме берем путь из window.FX_CONFIG или из переменной окружения как фолбэк.
const routerBasePath =
	import.meta.env.VITE_APP_BUILD_MODE === "standalone"
		? "/"
		: (windowConfig.routerBasePath ?? import.meta.env.VITE_APP_ROUTER_BASEPATH ?? import.meta.env.BASE_URL);

// 4. Определяем apiBasePath. Он также может быть динамическим.
// Сначала берем из конфига
// Потом берем из окружения
// Потом проверяем - а может у нас ассеты по полному пути берутся? тогда надо апи оттуда же брать
// Потом уже берем с текущего пути
const apiBasePath =
	(windowConfig.apiBasePath ?? import.meta.env.VITE_APP_API_BASE_PATH != null)
		? import.meta.env.VITE_APP_API_BASE_PATH
		: import.meta.env.BASE_URL.toLowerCase().startsWith("http")
			? // убираем трейлинг слеш
				import.meta.env.BASE_URL.replace(/\/+$/, "")
			: // Убирается трейлинг слеш
				`${window.location.origin}${routerBasePath}`.replace(/\/+$/, "");

const routerType =
	windowConfig.routerType == null
		? import.meta.env.VITE_APP_BUILD_MODE === "standalone"
			? "HashRouter"
			: "BrowserRouter"
		: windowConfig.routerType == "HashRouter"
			? "HashRouter"
			: "BrowserRouter";

const normalizedBaseUrl = routerBasePath !== "/" && routerBasePath !== "./" ? routerBasePath : "";

const game = windowConfig.game;

// 5. Экспортируем единый объект конфигурации
export const AppConfig: AppConfig = {
	game,
	routerBasePath,
	apiBasePath,
	routerType,
	normalizedBaseUrl
};

// export const routerBasePath =
// 	import.meta.env.VITE_APP_BUILD_MODE !== "standalone"
// 		? (import.meta.env.VITE_APP_ROUTER_BASEPATH ?? import.meta.env.BASE_URL)
// 		: undefined;
//
//
// // export const apiBasePath = import.meta.env.VITE_APP_API_BASE_PATH
// // 	? import.meta.env.VITE_APP_API_BASE_PATH
// // 	: `${window.location.origin}${normalizedBaseUrl}`;
//
// export const apiBasePath =
// 	import.meta.env.VITE_APP_API_BASE_PATH != null
// 		? import.meta.env.VITE_APP_API_BASE_PATH
// 		: normalizedBaseUrl.startsWith("http")
// 			? normalizedBaseUrl
// 			: `${window.location.origin}${normalizedBaseUrl}`;
